"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserialize = exports.serialize = void 0;

var deserialize = function deserialize(v) {
  var r = JSON.parse(v);

  if (r.type && r.type === 'Buffer') {
    return Buffer.from(r.data);
  }

  return r;
};

exports.deserialize = deserialize;

var serialize = function serialize(v) {
  return JSON.stringify(v);
};

exports.serialize = serialize;